import { render, staticRenderFns } from "./orderDetailTable.vue?vue&type=template&id=3c85086a&scoped=true&"
import script from "./orderDetailTable.vue?vue&type=script&lang=js&"
export * from "./orderDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailTable.vue?vue&type=style&index=0&id=3c85086a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c85086a",
  null
  
)

export default component.exports